<template>
    <d2-container :filename="filename">
        <d2-crud
                :columns="columns"
                :data="data"
                :loading="loading"
                :pagination="pagination"
                title="分享管理"
                :rowHandle="rowHandle"
                :form-options="formOptions"
                @row-remove="handleRowRemove">
            <el-button slot="headerButton" @click="addData">
                <d2-icon name="plus"></d2-icon>
            </el-button>
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>

        <template slot="footer">
            www.heanny.cn
        </template>
    </d2-container>
</template>

<script>
    import ShareEditor from "@/pages/components/shareEditor.vue"

    export default {
        comments: [ShareEditor],
        data() {
            return {
                filename: __filename,
                loading: false,
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                },
                columns: [
                    {
                        title: 'ID',
                        key: 'id',
                        width:'50'
                    },
                    {
                        title: '缩略图',
                        key: 'imgurl',
                        component: {
                            // name: "div",
                            render: function (h, row) {
                                return h("img", {
                                    attrs: {
                                        src: row.imgurl ? "//cdn.heanny.cn/Courses/" + row.imgurl : "//cdn.heanny.cn/Courses/moren.jpg?!23",
                                        height: '50px',
                                        width: '50px',
                                    }
                                })
                            }
                        },
                        width:'80'
                    }, {
                        title: '标题',
                        key: 'title'
                    },
                    {
                        title: '链接',
                        key: 'bdurl'
                    },
                    {
                        title: '类别',
                        key: 'cclass',
                        width:'100'
                    },
                    {
                        title: '作者',
                        key: 'user',
                        width:'80'
                    },
                    {
                        title: '时间',
                        key: 'time',
                        width:'100'
                    },
                    {
                        title: '编辑',
                        key: 'editor',
                        component: {
                            render: function (h, row) {
                                return h(ShareEditor, {
                                    attrs: {
                                        row: row,
                                    }
                                })
                            }
                        },
                        width:'70'
                    }
                ],
                data: [],
                rowHandle: {
                    columnHeader: '删除',
                    remove: {
                        text: '',
                        icon: 'el-icon-delete',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                    },
                    width:'70'
                },
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                }
            }
        },
        methods: {
            addData() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'share-add',
                })
                location.href = '/#/share/add'
            },
            handleRowRemove({index, row}, done) {
                this.loading = true
                this.$request({url: 'delShareById.do', data: {id: row.id}}).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    done()
                    this.loading = false
                }).catch(err => {
                    this.$message.error('删除失败');
                    this.loading = false

                })

            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({url: "getShares.do"}).then(res => {
                    _this.data = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.loading = false
                    })
            }
        },
        created: function () {

            this.getData()
        }
    }
</script>
